import { StyledRangePicker } from './RangePickerStyles';
import { CalendarIcon } from '@/icons';
import { RangePickerProps } from 'antd/es/date-picker';

const RangePicker = (props: RangePickerProps): JSX.Element => (
  <StyledRangePicker suffixIcon={<CalendarIcon />} {...props} />
);

export default RangePicker;
